import React from "react";
import { FormattedMessage } from "react-intl";
import StepGuideNumbers from "../../StepGuideNumbers";
import Step2Form from "./components/Step2Form";
import useMediaQuery from "utils/hooks/useMediaQuery";
import StepNavigationBack from "../../StepNavigationBack";
import StepInfoContainer from "../../StepInfo/container";
import "./styles/Step2.scss";

const Step2 = () => {
  const isMobile = useMediaQuery("(max-width: 1199px)");
  const progressStepValue = 66;
  const currentStep = [0, 1, 2];

  return (
    <main className="step0--main">
      <StepInfoContainer
        subtitle={
          <FormattedMessage
            id="ProjectStepForm.step1.subtitle"
            description="Subtitle of Step form 1"
            defaultMessage="Formulario | Biblioteca de Proyectos"
          />
        }
      />
      {isMobile && (
        <StepGuideNumbers
          currentStep={currentStep}
          progressStepValue={progressStepValue}
          isMobile={isMobile}
        />
      )}
      <section className="step0--main__wizard-form">
        {!isMobile && <StepGuideNumbers currentStep={currentStep} />}
        <div className="main__wizard-container bg-light col-12 col-lg-8 p-3 p-lg-5">
          <progress max={100} value={progressStepValue} className="w-100" />
          <StepNavigationBack />
          <h5 className="step0--main__form-title mt-4 font-weight-bold">
            <FormattedMessage
              id="ProjectStepForm.step2.title"
              defaultMessage="Información detallada del proyecto"
            />
          </h5>
          <hr />
          <Step2Form />
        </div>
      </section>
    </main>
  );
};

export default Step2;
